export const locales = ["fr-FR","en-GB"]
export const fileNamesByLang = {"fr":"fr","fr-FR":"fr","en":"en","en-GB":"en"}/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {"fr":"fr-FR","fr-FR":"fr-FR","en":"en-GB","en-GB":"en-GB"}